import { useState } from 'react';

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const textarea = form.querySelector('textarea');
    if (textarea && textarea.value.length > 500) return;
    setSubmitting(true);
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => data.append(key, value as string));
    try {
      await fetch('https://readdy.ai/api/form/d70hrjr2m2156g4s6sog', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      /* handle silently */
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="w-full bg-stone-800 py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          {/* Left: Info */}
          <div>
            <p className="text-amber-400 text-xs tracking-[0.5em] uppercase mb-3">Contact</p>
            <h2
              className="text-white text-3xl lg:text-4xl font-light mb-4"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              お問い合わせ
            </h2>
            <div className="w-12 h-px bg-amber-500 mb-6" />
            <p className="text-stone-300 text-sm leading-relaxed mb-10">
              貸別荘・民泊の開業をお考えの方、運営でお困りの方、
              まずはお気軽にご相談ください。専門スタッフが丁寧にご対応いたします。
            </p>
            <div className="flex flex-col gap-5">
              {[
                { icon: 'ri-mail-line', label: 'MAIL', value: 'globalvillage4548tvc@gmail.com' },
                { icon: 'ri-time-line', label: '営業時間', value: '平日 9:00〜18:00' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-600/20 rounded-full flex-shrink-0">
                    <i className={`${item.icon} text-amber-400`} />
                  </div>
                  <div>
                    <p className="text-stone-500 text-xs tracking-wider">{item.label}</p>
                    <p className="text-stone-200 text-sm font-medium">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Form */}
          <div className="bg-stone-700/50 rounded-lg p-8">
            {submitted ? (
              <div className="text-center py-12">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-600/20 rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-3xl text-amber-400" />
                </div>
                <h3 className="text-white text-xl font-light mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  送信完了しました
                </h3>
                <p className="text-stone-400 text-sm">お問い合わせありがとうございます。担当者よりご連絡いたします。</p>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-5">
                <div>
                  <label className="text-stone-400 text-xs mb-1.5 block tracking-wide">お名前 <span className="text-amber-500">*</span></label>
                  <input
                    name="name"
                    type="text"
                    required
                    placeholder="山田 太郎"
                    className="w-full bg-stone-600/50 text-white text-sm placeholder-stone-500 border border-stone-600 rounded-md px-4 py-3 outline-none focus:border-amber-500 transition-colors"
                  />
                </div>
                <div>
                  <label className="text-stone-400 text-xs mb-1.5 block tracking-wide">メールアドレス <span className="text-amber-500">*</span></label>
                  <input
                    name="email"
                    type="email"
                    required
                    placeholder="info@example.com"
                    className="w-full bg-stone-600/50 text-white text-sm placeholder-stone-500 border border-stone-600 rounded-md px-4 py-3 outline-none focus:border-amber-500 transition-colors"
                  />
                </div>
                <div>
                  <label className="text-stone-400 text-xs mb-1.5 block tracking-wide">電話番号</label>
                  <input
                    name="phone"
                    type="tel"
                    placeholder="090-0000-0000"
                    className="w-full bg-stone-600/50 text-white text-sm placeholder-stone-500 border border-stone-600 rounded-md px-4 py-3 outline-none focus:border-amber-500 transition-colors"
                  />
                </div>
                <div>
                  <label className="text-stone-400 text-xs mb-1.5 block tracking-wide">お問い合わせ内容 <span className="text-amber-500">*</span></label>
                  <textarea
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    placeholder="ご相談内容をご記入ください（500文字以内）"
                    className="w-full bg-stone-600/50 text-white text-sm placeholder-stone-500 border border-stone-600 rounded-md px-4 py-3 outline-none focus:border-amber-500 transition-colors resize-none"
                  />
                </div>
                <button
                  type="submit"
                  disabled={submitting}
                  className="whitespace-nowrap w-full py-4 bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium rounded-md transition-all duration-300 cursor-pointer disabled:opacity-60"
                >
                  {submitting ? '送信中...' : '送信する'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
